import FiltroSolicitudes from '../../components/matriculas/solicitudes/FiltroSolicitudes';

const Solicitudes = () => (
  <div>
    <div style={{ marginBottom: '16px' }}>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: '#111827', margin: 0 }}>Solicitudes</h1>
      <p style={{ color: '#9ca3af', marginTop: '2px', marginBottom: 0, fontSize: '0.8rem' }}>
        Gestión de solicitudes de matrícula
      </p>
    </div>
    <FiltroSolicitudes />
  </div>
);

export default Solicitudes;
